import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { Grid, IconButton, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FormTitle, Text, SelectField } from "ui-components/Form";
import Fieldset from "layouts/views/components/Fieldset";
import { OldSelectField } from "./OldSelectField";

import { useState, useEffect } from "react";
import { getRackList, getLocationsByRack } from "services/data.internal.service";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";

import {
  getVendorOptions,
  getCategoryOptions,
  getGroupOptions,
  getSubGroupOptions,
  getSKUListByVendCode,
  getPreferredLocation,
} from "services/data.internal.service";
import { getLocationsSetAsPickFace } from "services/data.internal.service";
import { SelectFields } from "ui-components/Form";
import { SwitchField } from "ui-components/Form";

import { StripedDataGrid } from "layouts/views/components/Grid";
import styled from "@emotion/styled";
import { selectionColumns } from "./column";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";

const CustomStyledDataGrid = styled(StripedDataGrid)({
  ".MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal !important",
    lineHeight: 1,
  },
  ".MuiDataGrid-columnHeader": {
    backgroundColor: "#f0f2f5",
  },
  ".MuiDataGrid-cell": {
    whiteSpace: "normal !important",
    "word-wrap": "break-word !important",
  },
  ".right-align-header": {
    textAlign: "right",
  },
});

function PreferredLocationInfo(props) {
  const {
    formRender,
    control,
    errors,
    setValue,
    watch,
    customerCode,
    locationsId,
    setLocationsId,
    selectedCells,
    setSelectedCells,
    selectedSKU,
    setSelectedSKUs,
    skuOptions,
    setSkuOptions,
    pickFaceLoc,
    setPickFaceLoc,
  } = props;

  //test render
  const [warehouseCode, zoneID, rack, locationID, skuList] = watch([
    "warehouseCode",
    "zoneID",
    "rack",
    "locationID",
    "skuList",
  ]);

  const [locationSelection, setLocationSelection] = useState([]);

  useEffect(() => {
    if (zoneID !== null)
      setValue("zoneID", null);
  }, [warehouseCode])

  useEffect(() => {
    if (rack !== null)
      setValue("rack", null);
  }, [zoneID])

  useEffect(() => {
    // if (Boolean(locationID)) setValue("locationID", []);
    // if (selectedCells.length !== 0) {
    //   setSelectedCells([]);
    // }
    if (rack === null && locationsId.length !== 0) setLocationsId([]);
    if (Boolean(locationSelection)) setLocationSelection([]);
  }, [rack])

  useEffect(() => {
    if (Boolean(locationSelection)) setValue("locationID", locationSelection);
  }, [locationSelection]);

  const [existingLocation, setExistingLocation] = useState([]);
  const [existingDetail, setExistingDetail] = useState([])

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [rackOptions, setRackOptions] = useState([]);
  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      const options = data.data.data.map((v) => v).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      setWarehouseOptions([...options]);
    },
  });
  useZoneOptionsQuery({
    whCode: warehouseCode,
    zoneType: "Storage",
    enabled: warehouseCode != null,
    onSuccess: (data) => {
      const options = data.data.data.map((v) => v).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      setZoneOptions([...options]);
    },
  });
  const rackListReq = {
    whCode: warehouseCode,
    id: zoneID,
    rack: rack,
  };
  useQuery({
    queryKey: ["racks", warehouseCode, zoneID],
    queryFn: () => {
      if (warehouseCode && zoneID) return getRackList(rackListReq);
      return {};
    },
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null,
    onSuccess: (data) => {
      if (data.data) {
        setRackOptions(data.data.map((r) => r).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())));
      }
    },
  });
  useQuery({
    queryKey: ["locations", rack],
    queryFn: () => {
      if (rack) return getLocationsByRack(rackListReq);
      return {};
    },
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null && rack != null,
    onSuccess: (data) => {
      if (data.data) {
        setLocationsId(data.data.sort((a, b) => a.locationID.toLowerCase().localeCompare(b.locationID.toLowerCase())));
        // const locations = data.data;
        // let maxRow = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.lLevel)
        // );
        // let maxColumn = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.bay)
        // );
        // let numberOfSlot = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.slot)
        // );
        // if (numberOfSlot > 0) maxColumn = maxColumn * numberOfSlot;
        // let table = [];
        // for (var i = 0; i < maxRow; i++) {
        //   let row = Array(maxColumn).fill("");
        //   let locationsInRow = locations.filter((x) => x.lLevel === i + 1);
        //   if (locationsInRow.length > 0) {
        //     for (var j = 0; j < locationsInRow.length; j++) {
        //       let index = (locationsInRow[j].bay - 1) * numberOfSlot + locationsInRow[j].slot - 1;
        //       row[index] = locationsInRow[j].locationID;
        //     }
        //   }
        //   table.unshift(row);
        // }
        // setLocationsId(table);
      } else {
        // setLocationsId([]);
        // setSelectedCells([]);
        // setRoutingDirection("no-direction");
      }
    },
  });

  useQuery({
    queryKey: ["existing-pick-face", rack],
    queryFn: () => getLocationsSetAsPickFace(rackListReq),
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null && rack != null,
    onSuccess: (data) => {
      const loc = data.data.data.map((v) => v);
      setPickFaceLoc([...loc]);
    },
  });

  const [vendorCodeOptions, setVendorCodeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [subgroupOptions, setSubGroupOptions] = useState([]);
  const [vendorCode, setVendorCode] = useState(null);
  const [category, setCategory] = useState(null);
  const [group, setGroup] = useState(null);
  const [subgroup, setSubGroup] = useState(null);
  const [skuCodes, setSKUCodes] = useState("");

  useQuery({
    queryKey: ["vendor-options", customerCode],
    queryFn: () => getVendorOptions({ custCode: customerCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setVendorCodeOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["category-options", [customerCode, vendorCode]],
    queryFn: () => getCategoryOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setCategoryOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["group-options", [customerCode, vendorCode]],
    queryFn: () => getGroupOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setGroupOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["subgroup-options", [customerCode, vendorCode]],
    queryFn: () => getSubGroupOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setSubGroupOptions(data.data.data.map((x) => x));
    },
  });

  const [loadSKU, setLoadSKU] = useState(false);
  const [loadPrefLoc, setLoadPrefLoc] = useState(false);

  //load exisitng location when pressed Load SKU, and plot table

  const loadSKUList = () => {
    setLoadSKU(!loadSKU);
    setLoadPrefLoc(!loadPrefLoc);
  };

  const SKUReq = {
    custCode: customerCode,
    vendCode: vendorCode,
    category: category,
    group: group,
    subgroup: subgroup,
    skuCodes: skuCodes
  };
  useQuery({
    queryKey: ["sku-options", [customerCode, vendorCode, category, group, subgroup, skuCodes]],
    queryFn: () => getSKUListByVendCode(SKUReq),
    enabled: loadSKU,
    onSuccess: (data) => {
      let result = data.data.data.map((x) => ({
        id: `${x.customerCode}_${x.vendorCode}_${x.skuCode}`,
        skuCode: x.skuCode,
        customerCode: x.customerCode,
        vendorCode: x.vendorCode,
        category: x.category,
        group: x.skuGroup,
        subgroup: x.skuSubGroup,
      }));
      setSkuOptions(result);
      setLoadSKU(!loadSKU);
    },
  });
  useQuery({
    queryKey: ["existing-preferred-location", [warehouseCode, zoneID, rack, customerCode]],
    queryFn: () =>
      getPreferredLocation({
        warehouseCode: warehouseCode,
        zoneID: zoneID,
        rack: rack,
        customerCode: customerCode,
      }),
    enabled: skuOptions.length > 0 && locationsId.length > 0,
    onSuccess: (data) => {
      let result = data.data.data.preferredLocationDetails;
      const tempLoclist = [];
      const tempDetList = [];
      result.forEach((detail) => {
        const { locationId, skuCode, customerCode, vendorCode, ...remaining } = detail;

        const locationIndex = tempLoclist.findIndex((current) => current === locationId);
        if (locationIndex === -1) {
          tempLoclist.push(locationId);
        }

        const itemIndex = tempDetList.findIndex((data) =>
          data.skuCode === skuCode &&
          data.customerCode === customerCode &&
          data.vendorCode === vendorCode);
        if (itemIndex === -1) {
          tempDetList.push({
            skuCode,
            vendorCode,
            customerCode,
            locations: [locationId],
          });
        } else {
          tempDetList[itemIndex].locations.push(locationId);
        }
      });
      setExistingLocation(tempLoclist);
      setExistingDetail(tempDetList);
    },
  });

  useEffect(() => {
    const selected = selectedSKU.map(x => {
      const [customerCodeStr, vendorCodeStr, skuCodeStr] = x.split('_');
      const customerCode = customerCodeStr !== "null" && customerCodeStr !== "undefined" ? customerCodeStr : null;
      const vendorCode = vendorCodeStr !== "null" && vendorCodeStr !== "undefined" ? vendorCodeStr : null;
      const skuCode = skuCodeStr !== "null" && skuCodeStr !== "undefined" ? skuCodeStr : null;
      const result = { customerCode: customerCode, vendorCode: vendorCode, skuCode: skuCode };
      return result;
    })
    setValue("skuList", selected);
  }, [selectedSKU]);

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "switch") {
      renderField = <SwitchField field={fieldProps} />
    } else if (data.type === "select") {
      if (!data.multiple) {
        renderField = (
          <SelectField
            field={fieldProps}
            options={
              (data.name === "warehouseCode" && warehouseOptions) ||
              (data.name === "zoneID" && zoneOptions) ||
              (data.name === "rack" && rackOptions)
            }
            control={control}
            errors={errors}
          />
        );
      } else if (data.multiple) {
        // if (data.name === "locationID" && locationsId.length !== 0) {
        //   renderField = (
        //     <>
        //       <Grid container spacing={3}>
        //         <Grid item xs={6}>
        //           <MDBox pt={1} pb={2}>
        //             <MDTypography color="info" variant="h5">
        //               Select Location
        //             </MDTypography>
        //           </MDBox>
        //         </Grid>
        //       </Grid>
        //       <Grid container spacing={3}>
        //         <Grid item xs={12}>
        //           <ClickableTable
        //             tableData={locationsId}
        //             values={locationID}
        //             fieldName={data.name}
        //             setFieldValue={setValue}
        //             selectedCells={selectedCells}
        //             setSelectedCells={setSelectedCells}
        //             existingLocation={existingLocation}
        //             pickFaceLoc={pickFaceLoc}
        //           />
        //         </Grid>
        //       </Grid>
        //     </>
        //   );
        // } else 
        if (data.name === "skuList") {
          const custProp = {
            disabled: true,
            value: customerCode || "",
            required: true,
            name: "customerCode",
            label: "Customer Code",
          };
          renderField = (
            <Fieldset label={data.label}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField sx={{ mb: 1.5 }} {...custProp} fullWidth />
                </Grid>
                <Grid item xs={6}>
                  <OldSelectField
                    field={{ name: "vendorCode", label: "Vendor Code", value: vendorCode || null }}
                    options={vendorCodeOptions}
                    onChange={(e, option) => setVendorCode(option)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <OldSelectField
                    field={{ name: "category", label: "Category", value: category || null }}
                    options={categoryOptions}
                    onChange={(e, option) => setCategory(option)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <OldSelectField
                    field={{ name: "group", label: "SKU Group", value: group || null }}
                    options={groupOptions}
                    onChange={(e, option) => setGroup(option)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <OldSelectField
                    field={{ name: "subgroup", label: "SKU Sub Group", value: subgroup || null }}
                    options={subgroupOptions}
                    onChange={(e, option) => setSubGroup(option)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Search SKU Code (split by comma ,) - Max 10"
                    fullWidth
                    value={skuCodes}
                    onChange={(e) => setSKUCodes(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MDBox
                    mt={2}
                    width="100%"
                    display="flex"
                    style={{ marginBottom: "10px" }}
                    justifyContent="center"
                  >
                    <MDButton color="info" variant="gradient" onClick={loadSKUList}>
                      Load SKU
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
              {skuOptions.length > 0 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <div style={{ height: 500, width: "100%" }}>
                      <CustomStyledDataGrid
                        autoHeight={false}
                        columns={selectionColumns}
                        rows={skuOptions}
                        checkboxSelection={true}
                        disableRowSelectionOnClick={true}
                        onRowSelectionModelChange={(id) => setSelectedSKUs(id)}
                        rowSelectionModel={selectedSKU}
                        sx={{
                          borderRadius: "0.75rem",
                        }}
                        initialState={{
                          pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        getRowHeight={() => "auto"}
                        hideFooterSelectedRowCount={true}
                      />
                    </div>
                    {/* <ClickableListbox
                      options={skuOptions}
                      selectedSKUs={selectedSKU}
                      setSelectedSKUs={setSelectedSKUs}
                      existingDetail={existingDetail}
                    /> */}
                  </Grid>
                </Grid>
              )}
              {/* {skuList !== null && skuList.length !== 0 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <DataTable
                      table={{
                        columns: [
                          { Header: "SKU Code", accessor: "skuCode" },
                          { Header: "Customer Code", accessor: "customerCode" },
                          { Header: "Vendor Code", accessor: "vendorCode" },
                          { Header: "Existing Location", accessor: "existingLocation"},
                          { Header: "Action", accessor: "action"},
                        ],
                        rows: skuList.map((d) => { 
                          const loc = existingDetail.findIndex(det => 
                            det.skuCode === d.skuCode && 
                            det.customerCode === d.customerCode &&
                            det.vendorCode === d.vendorCode
                        ) !== -1 ? 
                        existingDetail
                        .find(
                          (det) =>
                            det.skuCode === d.skuCode &&
                            det.customerCode === d.customerCode &&
                            det.vendorCode === d.vendorCode
                        )
                        .locations.join(", ") : "";
                          return({
                          skuCode: d.skuCode,
                          customerCode: d.customerCode,
                          vendorCode: d.vendorCode,
                          existingLocation: loc,
                          action: (
                            <MDBox>
                              <IconButton
                                color="error"
                                title="remove preferred location"
                                onClick={() => {
                                  let updated = [...selectedSKU];
                                  updated = updated.filter((prev) => 
                                    prev.skuCode !== d.skuCode ||
                                    prev.customerCode !== d.customerCode ||
                                    prev.vendorCode !== d.vendorCode
                                  );
                                  setSelectedSKUs(updated);
                                }}
                              >
                                <CancelButton />
                              </IconButton>
                            </MDBox>
                          )
                        })}),
                      }}
                    />
                  </Grid>
                </Grid>
              )} */}
            </Fieldset>
          );
        }
      }
    } else if (data.type === "multi-select") {
      if (data.name === "locationID") {
        renderField = (
          <SelectFields
            field={{
              name: "",
              label: "Location ID",
              value: locationSelection,
              errors: {},
              multiple: true,
              required: true,
            }}
            options={locationsId.map(x => x.locationID).filter(x => !pickFaceLoc.some(z => z == x))}
            onChange={(e, v) => setLocationSelection(v)}
          />
        );
      }
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title="New Preferred Location Information" />

      <MDBox mt={1.625}>
        {formRender.map((renders, i) => {
          if (renders[0].name === "skuList")
            return <>{renders.map((render, index) => renderFn(render, index, renders.length))}</>;
          else
            return (
              <Grid container spacing={3} key={i}>
                {renders.map((render, index) => renderFn(render, index, renders.length))}
              </Grid>
            );
        })}
      </MDBox>
    </MDBox>
  );
}

export default PreferredLocationInfo